import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { EzoomApiProvider } from './ezoom-api';

@Injectable()
export class HeadquartersProvider {

    constructor(
        public api: EzoomApiProvider,
        public storage: Storage,
    ) {}

    public get() {
        return new Promise((resolve, reject) => {
            this.storage.get('headquarters').then(data => {
                if (data != null){
                    resolve(data);
                }else{
                    this.api.get('headquarters').subscribe((response:any) => {
                        if (response.status){
                            this.storage.set('headquarters', response.data);
                            resolve(response.data);
                        }else{
                            resolve([]);
                        }
                    });
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/headquarters.ts